import { Alert, Box,Card, CardContent, Chip, Grid, LinearProgress, Link, Stack, Tooltip } from '@mui/material'
import TuneIcon from '@mui/icons-material/Tune'
import * as React from 'react'
import TablePagination from '@mui/material/TablePagination'
import Checkbox from '@mui/material/Checkbox'
import IconButton from '@mui/material/IconButton'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt'
import { Typography } from '@mui/material'
import CONSTANT from '../../Constant/Constant'
import api from '../../service/api'
import { useState, useEffect, forwardRef, useImperativeHandle, useContext } from 'react'
import SnackBar from './snackbar'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';  
import PersonRemoveOutlinedIcon from '@mui/icons-material/PersonRemoveOutlined';
import './ephTracker.css'
import PopUpMsg from '../../config/popUpMsg.json'
import DeselectIcon from '@mui/icons-material/Deselect';
import ClearIcon from '@mui/icons-material/Clear';
import { DirectionContext } from '../../context/DirectionProvider';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import RequestListSkeletonCard from './skeleton/requestListCard'
import EditCalendarIcon from '@mui/icons-material/EditCalendar';

const RequestList = forwardRef ((props, ref) => {
  const direction = useContext(DirectionContext);
  const [popUpMessages] = useState(PopUpMsg.ephInbox)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [dcrData, setDcrData] = useState([])
  const [nextToken, setNextToken] = useState({DCR: {All: false, MyAssignment: false}, Merge: { All: false, MyAssignment: false}})
  const [checkedList, setCheckedList] = useState([])
  const [selectedList, setSelectedList] = useState([])
  const [allDcr, setAllDcr] = useState({})
  const [progressBar, setProgressBar] = useState(false)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [snackMessage, setSnackMessage] = useState({'type': '', 'message':''})
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [disableAssignButton, setDisableAssignButton] = useState(true)
  const [showAlert, setShowAlert] = useState(false)
  const [currentTab, setCurrentTab] = useState({
    DCR: 'All',
    Merge: 'All'
  })
  const [searchData, setSearchData] = useState({DCR:{}, Merge:{}})
  const [totalCount, setTotalCount] = useState({DCR:{AllRequest:0, MyAssignments: 0, TotalRequest: 0, TotalMyAssignmentRequest: 0 }, Merge:{AllRequest:0, MyAssignments: 0, TotalRequest: 0, TotalMyAssignmentRequest: 0 }})
  const [selectedCard, setSelectedCard] = useState(null);
  const [filter, setFilter] = useState('All')
  const [disableNextButton, setDisableNextButton] = useState(false)
  const [activeTab, setActiveTab] = useState(props.selectedTab)
  const [skeletonView, setSkeletonView] = useState(false)
  const [noCountavailable, setNoCountavailable] = useState({DCR:{AllRequest: false, MyAssignments: false}, Merge:{AllRequest: false, MyAssignments: false}});
  
  let syncData = false
  let paginationIndexStart = "";
  let paginationIndexEnd = "";
  let paginationDataSliced = [];

  useImperativeHandle(ref, () => ({
    handleRequest, myAssignedRequest, closeDetails
  }));

  paginationIndexStart = page * rowsPerPage;
  paginationIndexEnd = page * rowsPerPage + rowsPerPage;
  paginationDataSliced = dcrData?.slice(
    paginationIndexStart,
    paginationIndexEnd
  );

  useEffect(() => {
    setSelectedCard(props?.selectedCard)
  }, [props?.selectedCard])

  const handleToggle = (value) => {
    props.getDetails(value)
    setSelectedCard(value);
  } 

  const closeDetails = (value) =>{
    setSelectedCard(value)
  }

  useEffect(()=>{
    if(filter != 'All'){
      if(filter == 'Pending'){
        handlePending()
        setPage(page)

      }
      else if(filter == 'Completed'){
        handleCompleted()
        setPage(page)
      }
      else if(filter == 'Unassigned'){
        handleUnAssigned()
        setPage(page)
      }
    }
  },[allDcr])

  const getStatusClassdcr = state => {
    switch (state) {
      case CONSTANT.STATE[0]:
        return 'text-white rounded py-2 px-3 bg-primary'
      case CONSTANT.STATE[1]:
        return 'text-white rounded py-2 px-3 approvedButton'
      case CONSTANT.STATE[2]:
        return 'text-white rounded py-2 px-3 bg-danger'
      case CONSTANT.STATE[3]:
        return 'text-white rounded py-2 px-3 bg-warning'
      case CONSTANT.STATE[4]:
        return 'text-white rounded py-2 px-3 bg-primary'
      case CONSTANT.STATE[5]:
        return 'text-white rounded py-2 px-3 approvedButton'
      case CONSTANT.STATE[6]:
        return 'text-white rounded py-2 px-3 bg-danger'
      case CONSTANT.STATE[7]:
        return 'text-white rounded py-2 px-3 appliedButton'
      case 'AWAITING_REVIEW':
        return 'text-white rounded py-2 px-3 bg-primary'
      case CONSTANT.STATE[9]:
        return 'text-white rounded py-2 px-3 appliedButton'
      case CONSTANT.STATE[10]:
        return 'text-white rounded py-2 px-3 bg-primary'
      case CONSTANT.STATE[11]:
        return 'text-white rounded py-2 px-3 bg-primary'
      default:
        return 'text-white rounded py-2 px-3 bg-primary'
    }
  }

  useEffect(() => { 
    handleRequest(props.query)
  }, [])

  useEffect(()=>{
    setSkeletonView(true)
    if(props.selectedTab != activeTab)
      {
        setActiveTab(props.selectedTab)
        handleRequest(props.query)
      }
    setTimeout(() => {
      setSkeletonView(false)
    }, 300);
  },[props.selectedTab])
  
  useEffect(()=>{
    props.getCurrentTab(currentTab[props.selectedTab])
  },[currentTab])

  const handleError = error => {
    // setErrorFlag(true);
    let errorDetail = error
    let msg = errorDetail.response
      ? errorDetail.response.data.errorCode
      : 'Internal Server Error!'
  }

  const rowsRemaining = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, dcrData.length);
    return endIndex - startIndex;
  }

  const handleRequest = async (body, pageNumber, refreshTab) => {
    if(pageNumber){
      setPage(pageNumber)
    } else{
      setPage(0)
    }

    if(!allDcr[props.selectedTab] || syncData ||  refreshTab ) {
      setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], AllRequest: false}})
      setProgressBar(true)
      setTotalCount({
        ...totalCount,
        [props.selectedTab]: {
          AllRequest: 0,
          TotalRequest: 0,
          MyAssignments:0
        },
      });
      getDcrAllRecords(body)
    }
    else {
      setProgressBar(true);
      setDcrData(allDcr[props.selectedTab]);
      setTotalCount({
        ...totalCount,
        [props.selectedTab]: {
          ...totalCount[props.selectedTab],
          AllRequest: totalCount[props.selectedTab]["TotalRequest"],
        },
      });
      setCheckedList([]);
      setFilter("All");
      setSearchData(body != undefined ? body : searchData);
      setProgressBar(false);
    }
  }

  const getDcrAllRecords = (body) => {
    api.getFilterRequest(
      body && body[props.selectedTab] !== undefined
        ? { ...body[props.selectedTab], requestType: props.selectedTab }
        : { requestType: props.selectedTab }
    )
      .then(response => {
        let dcrRecords = response.data;
        setDcrData(dcrRecords.Data);
        setAllDcr({ ...allDcr, [props.selectedTab]: dcrRecords.Data });
        setNextToken({ ...nextToken, [props.selectedTab]: {...nextToken[props.selectedTab], All: dcrRecords.NextToken} });
        setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], AllRequest: dcrRecords.NextToken ? true : false}});
        setTotalCount({
          ...totalCount,
          [props.selectedTab]: {
            AllRequest:dcrRecords.Data.length,
            MyAssignments: 0,
            TotalRequest: dcrRecords.Data.length
          },
        });
        // Reset other states after dcrRecords API succeeds
        setDisableAssignButton(true);
        setCheckedList([]);
        setCurrentTab({ ...currentTab, [props?.selectedTab]: 'All' });
        setFilter('All');
        setSearchData(body !== undefined ? body : searchData);
        setProgressBar(false);
        getAllDcrCount(body);
      })
      .catch((err) => {
        setProgressBar(false);
        handleError(err);
        setDcrData([]);
        setAllDcr({ ...allDcr, [props.selectedTab]: [] });
        setCurrentTab({ ...currentTab, [props?.selectedTab]: "All" });
      });
  }

  const getAllDcrCount = (body) => {
    api.getFilterRequest(
      body && body[props.selectedTab] !== undefined
        ? { ...body[props.selectedTab], count: true, requestType: props.selectedTab }
        : { count: true, requestType: props.selectedTab }
    )
      .then(response => {
        let dcrCount = response.data;
        setTotalCount({
          ...totalCount,
          [props.selectedTab]: {
            AllRequest: dcrCount?.AllRequests, 
            MyAssignments: dcrCount?.MyAssignments,
            TotalRequest: dcrCount?.AllRequests
          }
        });
        setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], AllRequest: false}});
      })
      .catch((err) => {
        setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], AllRequest: true}});
        handleError(err);
        //console.error("Error in dcrCount API:", err.message);
        // Optionally, set a fallback count if dcrCount fails
      });
  }


  const loadMoreData = async (newPage)=> {
    setProgressBar(true);
    setDisableNextButton(true);
    let advanceSearchData = {
      ...searchData[props.selectedTab],
      nextToken: nextToken[props.selectedTab][currentTab[props?.selectedTab]],
      requestType: props.selectedTab,
    };
    await api
      .getFilterRequest(
        searchData
          ? advanceSearchData
          : currentTab[props?.selectedTab] != "All"
          ? {
              myAssignments: true,
              nextToken: nextToken[props.selectedTab][currentTab[props?.selectedTab]],
              requestType: props.selectedTab,
            }
          : {
              nextToken: nextToken[props.selectedTab][currentTab[props?.selectedTab]],
              requestType: props.selectedTab,
            }
      )
      .then((response) => {
        let result = response.data;
        setDcrData([...dcrData, ...result.Data]);
        setAllDcr({
          ...allDcr,
          [props.selectedTab]: [...allDcr[props.selectedTab], ...result.Data],
        });
        setNextToken({ ...nextToken, [props.selectedTab]: {...nextToken[props.selectedTab], [currentTab[props?.selectedTab]]: result.NextToken} });
        //setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], [currentTab[props?.selectedTab] != "All" ? "MyAssignments" : "AllRequest"]: result.NextToken ? true : false}});

        if (noCountavailable[props.selectedTab][currentTab[props?.selectedTab] != "All" ? "MyAssignments" : "AllRequest"]) {
          currentTab[props?.selectedTab] != "All"
            ? setTotalCount({
                ...totalCount,
                [props.selectedTab]: {
                  AllRequest: totalCount[props.selectedTab]["AllRequest"],
                  MyAssignments:
                    totalCount[props.selectedTab]["MyAssignments"] +
                    result.Data.length,
                  TotalRequest:
                    totalCount[props.selectedTab]["TotalRequest"],
                },
              })
            : setTotalCount({
                ...totalCount,
                [props.selectedTab]: {
                  AllRequest:
                    totalCount[props.selectedTab]["AllRequest"] +
                    result.Data.length,
                  MyAssignments:
                    totalCount[props.selectedTab]["MyAssignments"],
                  TotalRequest:
                    totalCount[props.selectedTab]["TotalRequest"] +
                    result.Data.length,
                },
              });
        }
        setDisableAssignButton(true);
        setSnackMessage({
          type: "success",
          message: popUpMessages[0].newRecordsFetched.description,
        });
        setOpenSnackBar(true);
        setProgressBar(false);
        setDisableNextButton(false);
        let rowRemaining = rowsRemaining();
        if (rowRemaining == rowsPerPage) {
          setPage(newPage);
        }
      })
      .catch((error) => {
        setDisableNextButton(false);
        setProgressBar(false);
      });
  }
  const assignDcr = async (assignvalue) => {
    setProgressBar(true)
    let filteredList =[]
    if(currentTab[props?.selectedTab] =='All'){    
    selectedList.forEach((e)=> {
      if (e.AssignedToId === '' ){
      filteredList.push(e.Id)
    }})
    }
    if(currentTab[props?.selectedTab] !='All'){    
      selectedList.forEach((e)=> {
        if (e.DcrStatus === 'Requested' || e.DcrStatus === 'Pending' ){
        filteredList.push(e.Id)
      }})
    }
    setDisableAssignButton(true)
    await api.dcrAssign(assignvalue, filteredList,props.selectedTab ).then(response => {
      let message = response.data
      setSnackMessage({'type' : 'success', 'message': message.Message })  
      setOpenSnackBar(true)
      setCheckedList([])
      setSelectedList([])
      setDisableAssignButton(false)
      if(currentTab[props?.selectedTab] == 'All'){
        syncData = true
        handleRequest(props.query, page)
      }
      else{
        if(!assignvalue){props.setOpenDetails(false)}
        myAssignedRequest(props.query, page)
      }
     
    }).catch((error) => {    
      setSnackMessage({'type' : 'error', 'message': error.response.data.Message })
      setProgressBar(false)
      handleError(error)
      setOpenSnackBar(true)
      setDisableAssignButton(false)
    })
  }

  useEffect(()=>{
    if(selectedCard !== null && props.openDetails){
      const data = dcrData.find(dcr=>dcr.Id === selectedCard.Id)
      if (data){
        props.getDetails(data)
      }
      else if (!data && props.query.DCR.dcrStatus === "Unassigned"){
        props.setOpenAdvanceSearch(true)
        props.setOpenDetails(false)
      }
    }
  },[dcrData])

  useEffect(()=>{
    if(currentTab[props?.selectedTab] == 'All'){
      if(selectedList.length > 0 && selectedList.every((e)=> e.AssignedToId == '')){
        setShowAlert(false)
        setDisableAssignButton(false)        
      }
      else if(selectedList.length > 0 && selectedList.some((e)=> e.AssignedToId == '' && props.userId )){
        setShowAlert(false)
        setDisableAssignButton(false)        
        //you cant assign the already assign dcr
      }
      else if(selectedList.length > 0 && selectedList.some((e)=> e.AssignedToId == '' &&  e.AssignedToId != props.userId)){
        setSnackMessage({'type' : 'error', 'message': popUpMessages[0].requestAssign.assignedToSomeoneElse.replace(/{{DCR}}/g, activeTab == 'DCR'?'DCR': 'Merge request') })      
        setShowAlert(true)
        setDisableAssignButton(true)
      }
      else if(selectedList.length > 0 && selectedList.every((e)=> e.AssignedToId != props.userId )){      
        setSnackMessage({'type' : 'error', 'message': popUpMessages[0].requestAssign.assignedToSomeoneElse.replace(/{{DCR}}/g, activeTab == 'DCR'?'DCR': 'Merge request') })      
        setDisableAssignButton(true)
        setShowAlert(true)
        
      }    
      else if(selectedList.length > 0 && selectedList.some((e)=> e.AssignedToId == props.userId ) && selectedList.some((e)=> e.AssignedToId != props.userId )){
        setSnackMessage({'type' : 'error', 'message': popUpMessages[0].requestAssign.alreadyAssigned.replace(/{{DCRs}}/g, activeTab+'s') })
        setDisableAssignButton(true)
        setShowAlert(true)

      }
      else if(selectedList.length > 0 && selectedList.every((e)=> e.AssignedToId == props.userId )){
        setSnackMessage({'type' : 'error', 'message': popUpMessages[0].requestAssign.alreadySelfAssigned.replace(/{{DCR}}/g, activeTab == 'DCR'?'DCR': 'Merge request') })
        setDisableAssignButton(true)
        setShowAlert(true)
            
      }
    }
    else if(currentTab[props?.selectedTab] != 'All'){   
      if(selectedList.length > 0 && selectedList.every((e)=> e.DcrStatus != 'Requested' && e.DcrStatus != 'Pending' )){        
        setSnackMessage({'type' : 'error', 'message': popUpMessages[0].requestAssign.unAssign.replace(/{{DCR}}/g, activeTab == 'DCR'?'DCR': 'Merge request')})      
        setShowAlert(true)
        setDisableAssignButton(true)
      }
      else{
        setDisableAssignButton(false)
        setShowAlert(false)
      }
    }
    else{
      setDisableAssignButton(false)
    }
  },[checkedList])

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false)
  }

  async function myAssignedRequest (data, pageNumber) {
    setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], MyAssignments: false}});
    setProgressBar(true);
    setSearchData({ DCR: {}, Merge: {} });
    getMyAssigedDcrRecords(data, pageNumber)
  }

  const getMyAssigedDcrRecords = (data, pageNumber) => {
    api
    .getFilterRequest({
      ...data[props.selectedTab],
      myAssignments: true,
      requestType: props.selectedTab,
    })
    .then((response) => {
      let dcrRecords = response.data;
  
      setDcrData(dcrRecords.Data);
      setAllDcr({ ...allDcr, [props.selectedTab]: dcrRecords.Data });
      setNextToken({ ...nextToken, [props.selectedTab]: {...nextToken[props.selectedTab], MyAssignment: dcrRecords.NextToken} });
      setTotalCount({
        ...totalCount,
        [props.selectedTab]: {
          ...totalCount[props.selectedTab],
          MyAssignments: dcrRecords.Data.length,
          TotalMyAssignmentRequest: dcrRecords.Data.length,
        },
      });
      setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], MyAssignment: dcrRecords.NextToken ? true : false}});
      setDisableAssignButton(true);
      setFilter("All");
      setCheckedList([]);
      setSelectedList([]);
      setCurrentTab({ ...currentTab, [props?.selectedTab]: "MyAssignment" });
      setPage(pageNumber || 0); // Default to 0 if pageNumber is undefined
      setSearchData(data !== undefined ? data : searchData);
      setProgressBar(false);
      getMyAssigedDcrCount(data);
    })
    .catch((err) => {
      setProgressBar(false);
      handleError(err);
      setDcrData([]);
      setAllDcr({ ...allDcr, [props.selectedTab]: [] });
      setCurrentTab({ ...currentTab, [props?.selectedTab]: "MyAssignment" });
    });
  }


  const getMyAssigedDcrCount = (data) => {
    api
    .getFilterRequest({
      ...data[props.selectedTab],
      myAssignments: true,
      count: true,
      requestType: props.selectedTab,
    })
    .then((response) => {
      let dcrCount = response.data;
      setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], MyAssignments: false}});
      setTotalCount({
        ...totalCount,
        [props.selectedTab]: {
          ...totalCount[props.selectedTab],
          MyAssignments: dcrCount.MyAssignments,
          TotalMyAssignmentRequest: dcrCount.MyAssignments 
        },
      });
    }) .catch((err) => {
      setNoCountavailable({...noCountavailable, [props.selectedTab]:{...noCountavailable[props.selectedTab], MyAssignments: true}});
      handleError(err);
      //console.error("Error in dcrCount API:", err.message);
      // Optionally, set a fallback count if dcrCount fails
    });
  }


  const handleAllRequest = () =>{
    setFilter('All')
    setPage(0)
    setDcrData(allDcr[props.selectedTab])
    setTotalCount({...totalCount, [props.selectedTab]:{...totalCount[props.selectedTab], AllRequest : (currentTab[props?.selectedTab] == 'All' ? totalCount[props.selectedTab]['TotalRequest'] : totalCount[props.selectedTab]['TotalMyAssignmentRequest'] )}})
  }

  function requestsInTermsOf100(count) {    
    if (count % 100 === 0 && count >= 100) {
      return `${Math.floor(count / 100) * 100 - 1}+`;
  } else {
      return count.toString();
  }
}

  const handlePending = () => {
    setFilter('Pending')
    setPage(0)
    let dataReq = []
    allDcr[props?.selectedTab].filter(item => {
      if (item.DcrStatus == 'Requested' || item.DcrStatus == 'Pending' ) {
        dataReq.push(item)
      }
      return dataReq
    })
    setDcrData(dataReq)
    setTotalCount({...totalCount, [props.selectedTab]:{...totalCount[props.selectedTab], AllRequest: dataReq.length}})
  }

  const handleCompleted = () => { 
        setFilter('Completed')
    setPage(0)
    let dataReq = []
    allDcr[props?.selectedTab].filter(item => {
      if (item.DcrStatus === 'APPROVED' || item.DcrStatus === 'REJECTED' || item.DcrStatus === 'APPLIED' || item.DcrStatus === 'Applied' 
          || item.DcrStatus === 'Approved' || item.DcrStatus === 'Rejected' ) {
        dataReq.push(item)
      }
      return dataReq
    })
    setDcrData(dataReq)
    setTotalCount({...totalCount, [props.selectedTab]:{...totalCount[props.selectedTab], AllRequest: dataReq.length}})
  }

  const handleUnAssigned = () => {
    setFilter('Unassigned')
    setPage(0)
    let dataReq = []
    
    allDcr[props?.selectedTab].filter(item => {
      if (!item.AssignedToId) {
        dataReq.push(item)
      }
      return dataReq      
    })    
    setDcrData(dataReq)
    setTotalCount({...totalCount, [props.selectedTab]:{...totalCount[props.selectedTab], AllRequest: dataReq.length}})
  }

  const handleAssign = (data, e, key) => {
    var prevCheckList = checkedList
    if (e.target.checked) {    
      if(selectedList.length <= 4) { 
      setCheckedList([...prevCheckList, key])
      setSelectedList([...selectedList, data])  
      }
      else{
        setSnackMessage({'type' : 'warning', 'message': popUpMessages[0].requestAssign.multipleSelection.replace(/{{DCRs}}/g, activeTab+'s') })
        setDisableAssignButton(true)
        setShowAlert(true)    
      }    
    } else if (!e.target.checked) {
      let indexOfItem = selectedList.findIndex(arr => arr === data)
      selectedList.splice(indexOfItem, 1)
      let keyOfItem = checkedList.findIndex(i => i == key)
      checkedList.splice(keyOfItem, 1)
      setCheckedList([...prevCheckList])
    }
  }

  const clearAllSelectedDCR = () =>{
    setCheckedList([])
    setSelectedList([])
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))    
    setPage(0)
  }
  
  const handlePageChange = (event, newPage) => {   
    
    if (page ===  Math.ceil(dcrData?.length / rowsPerPage) - 1){      
      if(nextToken[props.selectedTab][currentTab[props?.selectedTab]]){
        loadMoreData(newPage)  
      }else{
        setPage(newPage)
      }
    }
    else{
    setPage(newPage)
    }
  }

  const openFilterMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeFilterMenu = () => {
    setAnchorEl(null);
  };

  const closeAssignWarning = () =>{
    setShowAlert(false)
    setSelectedList([])
    setCheckedList([])  
  }

  const clearAllFilters = () =>{
    props.ClearAdvanceSearch()
  }

  return (
    <div >
      <Card sx={{ boxShadow: !props.openAdvanceSearch ? 3 : "0px 3px 15px #f6ccd0",
          border: !props.openAdvanceSearch ? null : "2px solid #f6ccd0", height: "100%"}} ref={props.cardRef}>
        <CardContent className='p-1'>
          <Grid container spacing={1} justifyContent={'space-between'} className='mt-1 mb-1' style={{paddingRight: '10px', paddingLeft: '10px'}}>
            <Grid item md={'auto'} sm={'auto'} xs={'auto'} className='p-0 m-0 _wg-dynamic-text'>
              <IconButton onClick={props.handleFilter} className='p-1.2 m-0' >
                {props.openAdvanceSearch ? (
                  <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Close Menu</span>}>
                  <MenuOpenIcon sx={{ float: 'left', transform:direction==='rtl'?'scaleX(-1)':''}} />
                  </Tooltip>
                ) : (
                  <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Open Menu</span>}>
                  <MenuIcon sx={{ float: 'left', transform:direction==='rtl'?'scaleX(-1)':'' }} />
                  </Tooltip>
                )}
              </IconButton>
              {currentTab[props?.selectedTab] != 'MyAssignment' &&
                <IconButton onClick={()=> assignDcr(true)} className='p-1.2 m-0' disabled={disableAssignButton || selectedList.length <= 0} > 
                <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Assign to me</span>}>
                <PersonAddAltIcon 
                  sx={{ cursor: 'pointer', float: 'left', transform:direction==='rtl'?'scaleX(-1)':'' }}
                />
                </Tooltip>
              </IconButton> 
              }

               {currentTab[props?.selectedTab] == 'MyAssignment' &&
                <IconButton onClick={()=> assignDcr(false)} className='p-1.2 m-0' disabled={disableAssignButton || selectedList.length <= 0} > 
                <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Unassign</span>}>
                < PersonRemoveOutlinedIcon 
                  sx={{ cursor: 'pointer', float: 'left', transform:direction==='rtl'?'scaleX(-1)':'' }}
                />
                </Tooltip>
              </IconButton> 
              }              
                
              <IconButton  onClick = {openFilterMenu } className={filter != 'All' ? 'p-1.2 m-0 filterButton' : 'p-1.2 m-0'}
              style={{padding:'4px'}}
              aria-controls={openMenu ? 'demo-positioned-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openMenu ? 'true' : undefined}>
                <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Filter</span>}>
                <TuneIcon
                  sx={{ cursor: 'pointer', float: 'left', color:(filter != 'All' ? 'white' : 'none'), transform:direction==='rtl'?'scaleX(-1)':''}}                 
                />
                </Tooltip>
              </IconButton> 
              {
                <Menu
                id="fade-menu"
                MenuListProps={{
                  'aria-labelledby': 'fade-button',
                  onMouseLeave : closeFilterMenu
                  
                }}
                anchorEl={anchorEl}
                open={openMenu}
                onClose={closeFilterMenu}
                TransitionComponent={Fade}                

              >
                <MenuItem defaultValue={'All'} onClick={handleAllRequest} >All</MenuItem>
                <MenuItem onClick={handleCompleted}>Completed</MenuItem>
                <MenuItem onClick={handlePending}>Pending</MenuItem>
                <MenuItem onClick={handleUnAssigned}>Unassigned</MenuItem>
                </Menu>
              }        
              {
                <IconButton onClick={()=> clearAllSelectedDCR()} className='p-1.2 m-0' hidden={selectedList.length <= 0} > 
                <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Clear all selected request</span>}>
                <DeselectIcon
                  sx={{ cursor: 'pointer', float: 'left', transform:direction==='rtl'?'scaleX(-1)':''}}
                />
                </Tooltip>
              </IconButton> 
              }              
              {
                <IconButton onClick={clearAllFilters} className='p-1.2 m-0' hidden ={!Object.keys(props.query[props.selectedTab]).length && filter == 'All'} > 
                <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Clear all Filters</span>}>
                <ClearIcon
                  sx={{ cursor: 'pointer', float: 'left' }}
                />
                </Tooltip>
              </IconButton> 
              }

              </Grid>
              <Grid item md={'auto'} sm={'auto'} xs={'auto'} textAlign={'center'} fontSize={'medium'} className='_wg-dynamic-text'>
                {/* <Grid item md={'auto'} sm={'auto'} xs={'auto'} sx={{margin: 'auto'}} className='p-0 _wg-dynamic-text'> */}
                <span dir={direction} className='text-muted'>Showing: </span>
                <span className='_wg-exclude'> {filter}</span>
                    {searchData[props.selectedTab]?.timeInterval !== undefined &&
                      <>
                        <span className='_wg-dynamic-text'> records {searchData[props.selectedTab]?.timeInterval === 'Custom'? ` from ${searchData[props.selectedTab]?.startDate} to ${searchData[props.selectedTab]?.endDate}` : ` for ${searchData[props.selectedTab]?.timeInterval}`} </span>
                        <IconButton onClick={props.onFocusSelect} className='m-0 p-0' > 
                          <Tooltip disableFocusListener className='_wg-dynamic-text' title={<span className='_wg-dynamic-text'>Adjust the Time interval filter.</span>}>
                          <EditCalendarIcon fontSize='small' sx={{ color:'#1976D2',  cursor: 'pointer', float: 'left', transform:direction==='rtl'?'scaleX(-1)':''}} />
                          </Tooltip>
                        </IconButton> 
                      </>
                    }            
            </Grid>            
            <Grid item md={'auto'} sm={'auto'} xs={'auto'} textAlign={'right'} className='pt-1 _wg-dynamic-text'>      
            <Link
                to='#'
                onClick={()=> currentTab[props?.selectedTab] !== 'All' && handleRequest(props.query, '' , true)}
                className='pointer text-decoration-none '                
                fontSize={14}
              >
              <span className={currentTab[props?.selectedTab] == "All" ? 'requests activeList _wg-dynamic-text': 'requests _wg-dynamic-text'}>
              {noCountavailable[props.selectedTab]['AllRequest'] ?
              <Tooltip title={<span className='_wg-dynamic-text'>{popUpMessages[0]?.totalCount.allRequest}</span>}>
                All Requests &nbsp;
                <Chip  size="small"  className='pl-1'
                label={totalCount && totalCount[props.selectedTab] && totalCount[props.selectedTab]['TotalRequest'] && totalCount[props.selectedTab]['TotalRequest'] == null ? 0 : (noCountavailable[props.selectedTab]['AllRequest'] && nextToken[props.selectedTab][currentTab[props?.selectedTab]] ? 
                  requestsInTermsOf100(totalCount[props.selectedTab]['TotalRequest']) : 
                requestsInTermsOf100(totalCount[props.selectedTab]['TotalRequest']))} sx={{backgroundColor:'#dc1c1c', color:'#ffffff'}}/> 
              </Tooltip>
              : 
              <>
                All Requests &nbsp;
                <Chip  size="small"  className='pl-1'
                label={totalCount && totalCount[props.selectedTab] && totalCount[props.selectedTab]['TotalRequest'] && totalCount[props.selectedTab]['TotalRequest'] == null ? 0 : (noCountavailable[props.selectedTab]['AllRequest'] && nextToken[props.selectedTab][currentTab[props?.selectedTab]] ? 
                  requestsInTermsOf100(totalCount[props.selectedTab]['TotalRequest']) : 
                  requestsInTermsOf100(totalCount[props.selectedTab]['TotalRequest'])) } sx={{backgroundColor:'#dc1c1c', color:'#ffffff'}}/>
              </>              
              }
              </span>&nbsp;
              </Link>
              | &nbsp;             
              <Link
                to='#'
                onClick={()=> currentTab[props?.selectedTab] !== 'MyAssignment' && myAssignedRequest(props.query)}
                className='pointer text-decoration-none '
                fontSize={14}
              >
                <span className={currentTab[props?.selectedTab] != "All" ? 'requests activeList _wg-dynamic-text': 'requests _wg-dynamic-text'}>
                {noCountavailable[props.selectedTab]['MyAssignments'] && totalCount[props.selectedTab]['MyAssignments'] != 0 ?
                <Tooltip title={<span className='_wg-dynamic-text'>{popUpMessages[0]?.totalCount.allRequest}</span>}>
                  My Assigned Requests &nbsp;
                  <Chip  size="small" 
                  label={totalCount && totalCount[props.selectedTab] && 
                    totalCount[props.selectedTab]['MyAssignments'] && 
                    totalCount[props.selectedTab]['MyAssignments'] == null ? 0 : 
                    (noCountavailable[props.selectedTab]['MyAssignments']  && nextToken[props.selectedTab][currentTab[props?.selectedTab]] && totalCount[props.selectedTab]['MyAssignments'] != 0  ? 
                    `${totalCount[props.selectedTab]['MyAssignments']} +` : 
                    totalCount[props.selectedTab]['MyAssignments'] )}  
                  sx={{backgroundColor:'#dc1c1c', color:'#ffffff'}} />
                </Tooltip>
                :
                <>
                My Assigned Requests &nbsp;
                  <Chip  size="small" 
                  label={totalCount && totalCount[props.selectedTab] && 
                    totalCount[props.selectedTab]['MyAssignments'] && 
                    totalCount[props.selectedTab]['MyAssignments'] == null ? 0 : 
                    (noCountavailable[props.selectedTab]['MyAssignments']  && nextToken[props.selectedTab][currentTab[props?.selectedTab]] && totalCount[props.selectedTab]['MyAssignments'] != 0  ? 
                    `${totalCount[props.selectedTab]['MyAssignments']} +` : 
                    totalCount[props.selectedTab]['MyAssignments'] )}  
                  sx={{backgroundColor:'#dc1c1c', color:'#ffffff'}} />                
                </>
                }
                </span>
              </Link>

            </Grid>
          </Grid>
          { 
            progressBar ?  <LinearProgress color="error" /> : <hr className='p-0 mb-0 mt-0'></hr>
          }
          {showAlert && selectedList.length > 0 &&
            <Alert severity='warning' className='_wg-dynamic-text' onClose={()=> closeAssignWarning()}>
             {snackMessage.message}
            </Alert>
            
          }
          
          <div
            className='request-list mt-1'
            style={{
              overflowX: 'hidden',
              overflowY: 'scroll',
              height: '65vh'
            }}
          >

            {/* Skeleton Code Starts */}

            {
              (progressBar || skeletonView) &&
              Array(rowsPerPage).fill(null).map((index) => {
                return (
                  <RequestListSkeletonCard direction key={index}/>
                )
              })
            }

            {/* End of the Skeleton Code */}

            {!skeletonView &&
              (
                !progressBar && paginationDataSliced?.length > 0 ? (
              paginationDataSliced.map((item, index) => {
                const labelId = `checkbox-list-label-${item.id}`

                return (
                   <Card
                    key={index}
                    className='mb-3'
                    sx={{
                      cursor: 'pointer',
                      display: "flex",
                      flexDirection: 'row',
                      borderRadius: '4px',
                      borderRight: '1px solid #eeeeee',
                      backgroundColor: selectedCard === item ? 'rgb(230, 242, 255)' : 'white',
                    }}
                  >
                    {/* Tooltip code for CRM and ECS DCR categorization  */}
                    <Tooltip disableFocusListener title={<span className='_wg-dynamic-text'>{item?.CrmDcrId ? 'Created via CRM DCR' : item?.is_consumer_dcr ? 'Created via Consumer API' : 'Created via ECS UI'} </span>}>
                      <Box className="hoverBorder"
                        sx={{
                          width: "10px",
                          backgroundColor: `${item?.CrmDcrId ? '#009edb' : item?.is_consumer_dcr ? '#F4C430' : '#ce2a1d'}`,
                          borderRadius: '4px 0 0 4px',
                          height: "auto",
                          marginRight: '5px'
                        }}></Box>
                    </Tooltip>
                      <CardContent
                        className='p-2'
                        role={undefined}
                        sx={{
                          flex:"1",
                        }}                 
                      >
                        <Grid container columnSpacing={2}>
                          <Grid item md={0.6} sm={0.7} xs={1} margin={'auto'}>
                            <Checkbox
                              edge='start'
                              checked={checkedList?.includes(item.Id)}
                              tabIndex={-1}
                              inputProps={{ 'aria-labelledby': labelId }}
                              onChange={e => handleAssign(item, e, item.Id)}
                            />
                          </Grid>
                          <Grid item md={9.3} sm={8.3} xs={9} onClick={()=>handleToggle(item)} className='_wg-dynamic-text'>
                            <Stack
                              flexWrap={'wrap'}
                              direction='row'
                              justifyContent='space-between'
                              alignItems='left'
                              gap={1}
                              className='p-0 m-0'
                            >
                              <Typography margin={0} variant='p' fontSize={14} className='_wg-dynamic-text'>
                                <span dir={direction} className='text-muted'>{activeTab == 'DCR' ? `DCR Id:` : `Merge Id:`} </span>
                                <span className='_wg-exclude'>{item.Id}</span>
                              </Typography>

                              <Typography
                                margin={0}
                                fontSize={14}
                                variant='p'
                                className='p-0 m-0 _wg-dynamic-text'
                              >
                                <span dir={direction} className='text-muted _wg-dynamic-text'>Country: </span>
                                <span className='_wg-exclude'>{item.Country}</span>
                              </Typography>
                            </Stack>
                            <Stack
                              flexWrap={'wrap'}
                              direction='row'
                              justifyContent='space-between'
                              alignItems='left'
                              gap={1}
                              className='p-0 m-0 _wg-dynamic-text'
                            >
                              <Typography margin={0} variant='p' fontSize={14}>
                                <span dir={direction} className='text-muted _wg-dynamic-text'>Created: </span>
                                <span className='_wg-exclude'>{new Date(item.CreatedDate).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric'} )}</span>
                              </Typography>

                              <Typography margin={0} variant='p' fontSize={14}>
                                <span dir={direction} className='text-muted _wg-dynamic-text'>
                                  {'Created By: '} 
                                </span>
                                <span className='_wg-exclude'>
                                  {
                                    item?.RequestorName ? item?.RequestorName?.includes(" - Network") ? item.RequestorName.split(" - Network")[0].trim() + ` (${item.CreatedBy})` : item.RequestorName + ` (${item.CreatedBy})` : item.CreatedBy || `N/A`
                                  }
                                </span>
                              </Typography>
                              <Typography margin={0} variant='p' fontSize={14} className='_wg-dynamic-text'>
                                <span dir={direction} className='text-muted _wg-dynamic-text'>Assigned To: </span>
                                <span className='_wg-exclude'>{item.AssignedToId ? item.AssignedToId : 'None'}</span>
                              </Typography>
                            </Stack>{' '}
                          </Grid>
                          <Grid item md={2} sm={3} xs={2}
                            margin={'auto'}
                            textAlign={'right'}
                            onClick={()=>handleToggle(item)}
                          >
                            <Tooltip disableFocusListener title={<span className='_wg-dynamic-text'>{popUpMessages[0]?.statusMessage[(item?.DcrStatus || item?.status).toUpperCase()]}</span>}>
                            <div
                              className={getStatusClassdcr(item.status || item.DcrStatus)}
                              style={{ fontSize: 'small' , width: '100px', textAlign: 'center', float:'right'}}
                            >
                              {item?.DcrStatus || item?.status}
                            </div>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                )
              })
            ) : (
                  !progressBar &&
              <center className='_wg-dynamic-text' style={{ margin: 'auto', verticalAlign: 'middle' }}>No requests found</center>
                )
            )}
          </div>
          <TablePagination
            className='_wg-dynamic-text'
            component='div'
            count={currentTab[props.selectedTab] === 'All' ? totalCount[props.selectedTab]['AllRequest'] : totalCount[props.selectedTab]['MyAssignments']}
            page={page}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[10, 20, 30]}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to, count }) => noCountavailable[props.selectedTab][currentTab[props.selectedTab] === 'All' ? 'AllRequest' : 'MyAssignments' ] && nextToken[props.selectedTab][currentTab[props?.selectedTab]]? `${from}-${to} of ${requestsInTermsOf100(count)}` :`${from}-${to} of ${count}`}
            slotProps={{
              actions: {
                // Disable the Next button by passing a custom disabled prop
                nextButton: {
                  disabled: disableNextButton || dcrData?.length === 0 || (page === Math.ceil(dcrData.length / rowsPerPage) - 1 && !nextToken[props.selectedTab]?.[currentTab[props.selectedTab]])

                },
              },
            }}       
          />         
        </CardContent>
      </Card>

      {openSnackBar && 
      <SnackBar 
        openSnackBar = {openSnackBar}
        handleCloseSnackBar ={()=> handleCloseSnackBar()}
        message = {snackMessage}
      />
      }
      
    </div>
  )
});


export default RequestList;